module.exports = __webpack_public_path__ + "img/search.d853116a.png";